export default "__VITE_ASSET__KsRHhXkb__"